export default function CategoryHero() {
  return <section className="category-hero">
    <img className="hero-image" src={`${import.meta.env.BASE_URL}hero-colares.png`} alt="Modelo usando colares delicados dourados com medalha" fetchPriority="high" />
    <div className="hero-copy"><h1>COLARES</h1><p>Beleza em cada detalhe.</p></div>
    <p className="hero-signature">Mais que acessórios,<br />é a sua história.<span /></p>
  </section>;
}
